import React from 'react'

const Checkbox = props => (
  <div className="checkbox checkbox-css m-b-20">
    <input
      {...props.field}
      type="checkbox"
      id={`${props.field.name}_checkbox`}
      checked={props.field.value}
      disabled={props.readOnly}
    />
    <label htmlFor={`${props.field.name}_checkbox`}>{props.label}</label>
  </div>
)

export default Checkbox
